import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

// context
import { useIosInputFocusLightBox } from "../useIosInputFocusLightBox";

// components
import CloseModalButton from "./CloseModalButton";

//styles
import { convertPxToRem } from "frontend/components/helpers";

// Ios Modal Background
// #141824 orca
const BG_DARK = `rgba(20, 24, 36, 0.8)`;
// #FFFFFF snow
const BG_LIGHT = `rgba(255, 255, 255, 0.95)`;

const DarkStyled = styled.div``;
const LightStyled = styled.div``;

const LightBoxStyled = styled.div`
    transition: background-color 0.3s ease;

    ${({ $isOpen, $isDarkMode }) => {
        if ($isOpen) {
            return css`
                width: 100%;
                background-color: ${$isDarkMode ? BG_DARK : BG_LIGHT};

                position: fixed;
                z-index: 2000;
                left: 0rem;
                top: 0rem;
                right: 0rem;
                height: 100vh;

                ${DarkStyled} {
                    width: 100%;
                    height: ${convertPxToRem(250)};

                    display: flex;
                    align-items: flex-end;

                    ${LightStyled} {
                        width: 100%;
                        padding: ${convertPxToRem(10)} ${convertPxToRem(15)};
                    }
                }
            `;
        }
    }}
`;

const PlaceholderStyled = styled.div`
    height: ${({ $height }) => convertPxToRem($height)};
`;

// component
export const LightBox = ({ children }) => {
    const { isOpen, isDarkMode, height } = useIosInputFocusLightBox();

    return (
        <PlaceholderStyled $height={height}>
            <LightBoxStyled $isOpen={isOpen} $isDarkMode={isDarkMode}>
                <DarkStyled>
                    <LightStyled>
                        {children}
                        <CloseModalButton />
                    </LightStyled>
                </DarkStyled>
            </LightBoxStyled>
        </PlaceholderStyled>
    );
};

export default LightBox;

// prop-types
LightBox.propTypes = {
    children: PropTypes.any
};
